import React, { useEffect, useRef, useState } from 'react'
import CommentBoxModal from './CommentBoxModal';
import { AtSign, Download, Paperclip, Upload } from 'lucide-react';
import { getSocketConnection } from '../../../../socket/socketHelperConnection';
import GenericCustomButton from '../../../GenericCustomButton';
import { dispatchHandler } from '../../../../helper/apiHelperFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { AnimatePresence, motion } from 'framer-motion';
import Icons from '../../../../assets/icons';
import { Tooltip } from 'antd';
import LanguageTranslator from '../../../../locals/LanguageTranslator';

const  CommentBoxModalWrapper = (props = {}) => {

    const {mode = 'normal', isDocumentViewer} = props

    const dispatch = useDispatch();
    const downloadTranscriptDropdownRef = useRef(null);
    const downloadCommentTranscriptData = useSelector(state => state?.generalStore?.downloadCommentTranscriptData);

    useEffect(() => {
        if(downloadCommentTranscriptData?.isSuccess){
            if(downloadCommentTranscriptData?.data?.fileUrl){
                window.open(downloadCommentTranscriptData?.data?.fileUrl)
            }
        }
    },[downloadCommentTranscriptData])

    const handleChange = (type) => {
        let {item, comment} = props;
        switch(type){
            case "downloadTranscriptWithoutPrivateMessage" :
            case "downloadTranscript" : {
                dispatchHandler(dispatch, "downloadCommentTranscriptRequest", {
                    "private" : type == "downloadTranscriptWithoutPrivateMessage" ? 0 : 1,
                    "documentId": item?.[comment?.configKeys?.documentId] || "",
                    "documentNumber": item?.[comment?.configKeys?.documentNumber] || "",
                })    
                break;
            }
            default : {}
        }
    }

    const [openModal, setOpenModal] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(false);

    const handleOutsideClick = (e) => {
        if (
        downloadTranscriptDropdownRef.current &&
        !downloadTranscriptDropdownRef.current.contains(e.target)
        ) {
        setOpenDropdown(false);
        document.removeEventListener("mousedown", handleOutsideClick);
        }
    };

//    useEffect(() => {

//     document.addEventListener("mousedown", handleOutsideClick);

//     return () => {
//         document.removeEventListener("mousedown", handleOutsideClick);
//     };
//     }, []);


    return (
        <div className='flex h-full'>
            <CommentBoxModal
                {...props}
                isDocumentViewer={isDocumentViewer}
                mode = {mode}
            />

            {/* Render the Mentions here */}
            {
                <div className={`duration-200 overflow-hidden ${openModal == "mentions" ? 'visible opacity-100 pointer-events-auto w-[300px] min-w-[300px]' : 'invisible opacity-0 pointer-events-none w-[0px] min-w-[0px]'}`}>
                    {openModal == "mentions" && <CommentBoxModal
                        {...props}
                        mode="mentions"
                        outerMode={mode == "central" ? "mentions_central" : undefined}
                        closeSection={() => setOpenModal(false)}
                    />}
                </div>
            }

            {
                <div className={`duration-200 overflow-hidden ${openModal == "attachments" ? 'visible opacity-100 pointer-events-auto w-[300px] min-w-[300px]' : 'invisible opacity-0 pointer-events-none w-[0px] min-w-[0px]'}`}>
                    {openModal == "attachments" && <CommentBoxModal
                        {...props}
                        mode="attachments"
                        outerMode={mode == "central" ? "attachments_central" : undefined}
                        closeSection={() => setOpenModal(false)}
                    />}
                </div>
            }

            <div className={`p-[12px] bg-white z-[3] ${(mode === 'central' || isDocumentViewer) ? 'h-full' : 'h-screen'}`}>
                <ul className='space-y-3'>
                    <Tooltip
                        overlayClassName='!p-0'
                        overlayInnerStyle={{ fontSize: '12px' }}
                        placement="left"
                        title={<LanguageTranslator>Mentions</LanguageTranslator>}
                    >
                        <li onClick={() => setOpenModal(openModal == "mentions" ? false : "mentions")} className={`aspect-square p-[6px] flex items-center justify-center bg-gray-100 font-semibold cursor-pointer hover:opacity-75 ${openModal == "mentions" && 'bg-primary_light'}`}>
                            <span><AtSign className={`${openModal == "mentions" ? 'text-primary' : 'black'}`} size={17} /></span>
                        </li>
                    </Tooltip>
                    <Tooltip
                        overlayClassName='!p-0'
                        overlayInnerStyle={{ fontSize: '12px' }}
                        placement="left"
                        title={<LanguageTranslator>Attachments</LanguageTranslator>}
                    >
                        <li onClick={() => setOpenModal(openModal == "attachments" ? false : "attachments")} className={`aspect-square p-[6px] flex items-center justify-center bg-gray-100 font-semibold cursor-pointer hover:opacity-75 ${openModal == "attachments" && 'bg-primary_light'}`}>
                            <span><Paperclip className={`${openModal == "attachments" ? 'text-primary' : 'black'}`} size={17} /></span>
                        </li>
                    </Tooltip>
                    <div className='relative'>
                        <Tooltip
                            overlayClassName='!p-0'
                            overlayInnerStyle={{ fontSize: '12px' }}
                            placement="left"
                            title={<LanguageTranslator>Export Transcript</LanguageTranslator>}
                        >
                            <div 
                                className='cursor-pointer hover:opacity-75'
                                onClick={(e) => {
                                        e.stopPropagation();
                                        setOpenDropdown((prev) => !prev);
                                        setTimeout(() => document.addEventListener('click', handleOutsideClick),0)
                                }} 
                            >
                                <li className={`aspect-square p-[6px] flex items-center justify-center bg-gray-100 font-semibold ${openDropdown ? 'bg-primary_light' : ''} rounded-t-[3px]`}>
                                    <span><Upload className={`${openDropdown ? 'text-primary' : 'black'}`} size={17} /></span>
                                </li>
                                <div className='py-1 px-1 mt-[2px] bg-gray-100 flex items-center justify-center rounded-b-[3px]'><Icons.DownArrowFilled className='iconBlack'/> </div>
                            </div>
                        </Tooltip>

                        <AnimatePresence>
                            {
                                openDropdown && 
                                <motion.div
                                    ref={downloadTranscriptDropdownRef}
                                    style={{
                                        boxShadow: '0px 6px 20px 1px #DADADF'
                                    }}
                                    className='mt-[4px] absolute top-full right-0 z-[1] py-0.5 bg-white rounded-md text-fontBlack'
                                    initial={{ opacity: 0, scale: 0.9, y: -5}}
                                    animate={{ opacity: 1, scale: 1, y: 0}}
                                    exit={{ opacity: 0, scale: 0.9, y: -5}}
                                    transition={{
                                        duration: 0.2,
                                        type: "spring",
                                        // stiffness: 200,
                                        // damping: 15,
                                    }}
                                >
                                    <ul>
                                        <li 
                                            className='pl-3 pr-4 py-2 flex items-center gap-1.5 cursor-pointer hover:bg-dropdown_item_hover'
                                            onClick={!downloadCommentTranscriptData?.isLoading ? () => handleChange("downloadTranscript") : null}
                                        >
                                            <div><Upload size={16} color='#67768E' /></div>
                                            <p className='mb-0 text-xs whitespace-nowrap'><LanguageTranslator tag='span' className='font-medium'>Export</LanguageTranslator> <LanguageTranslator>(All)</LanguageTranslator></p>
                                        </li>
                                        <li
                                            className='pl-3 pr-4 py-2 flex items-center gap-1.5 cursor-pointer hover:bg-dropdown_item_hover'
                                            onClick={!downloadCommentTranscriptData?.isLoading ? () => handleChange("downloadTranscriptWithoutPrivateMessage") : null}
                                        >
                                            <div><Upload size={16} color='#67768E' /></div>
                                            <p className='mb-0 text-xs whitespace-nowrap'><LanguageTranslator tag='span' className='font-medium'>Export</LanguageTranslator> <LanguageTranslator>(Public Only)</LanguageTranslator></p>
                                        </li>
                                    </ul>
                                </motion.div>
                            }
                        </AnimatePresence>
                    </div>

                </ul>
            </div>
        </div>
    )
}

export default CommentBoxModalWrapper